import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { Tours } from "../../store/Tours";
import ToursForm from "../tours/ToursForm";

interface TourInfoFormProps {
  initialData: Tours;
  onNext: () => void;
  onPrev: () => void;
  onStartOver: () => void;
  onSave: (data: any, shoudSaveDraft: boolean) => void;
  hidePrev: boolean
}
const TourInfoForm: FunctionComponent<TourInfoFormProps> = ({
  initialData,
  onSave,
  onNext,
  onPrev,
  onStartOver,
  hidePrev
}) => {
  const onSubmit = (data: Tours) => {
    onSave(data, false);
    onNext();
  };
  const Language = useSelector(
    (rootState: RootState) => rootState.language.language?.content
  );
  return (
    <div className="row">
      <h4 className="com-font fw700 text-red text-capitalize">{Language?.general?.tour_info}</h4>
      <div className="col-lg-12 paddlr0 com-font">
        <p className="small fw700">
          {Language?.general?.tour_info_sub}
        </p>
      </div>
      <ToursForm
        isProviderForm={true}
        initialData={initialData}
        onSubmit={onSubmit}
        onSave={onSave}
        onPrev={onPrev}
        onStartOver={onStartOver}
        hidePrev={hidePrev}
      />
    </div>
  );
};

export default TourInfoForm;
